<template>
  <div class="form-horizontal">
    <div class="form-group">
      <label class="col-sm-2 control-label">名称</label>
      <div class="col-sm-10">
        <div class="input-group">
          <input type="text" class="form-control" placeholder="名称" v-model="clothe.name" disabled/>
          <span class="input-group-btn">
              <button class="btn btn-default" type="button" @click="dialog.price=!dialog.price">选择</button>
          </span>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label class="col-sm-2 control-label">价格</label>
      <div class="col-sm-10">
          <input type="text" class="form-control" placeholder="价格" v-model.number="clothe.price"/>
      </div>
    </div>
    <div class="form-group">
      <label class="col-sm-2 control-label">品牌</label>
      <div class="col-sm-10">
        <div class="input-group">
          <input type="text" class="form-control" placeholder="品牌" v-model="clothe.brand.text" disabled/>
          <span class="input-group-btn">
              <button class="btn btn-default" type="button" @click="dialog.brand=!dialog.brand">选择</button>
          </span>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label class="col-sm-2 control-label">颜色</label>
      <div class="col-sm-10">
        <div class="input-group">
          <input type="text" class="form-control" placeholder="颜色" v-model="clothe.color.text" disabled/>
          <span class="input-group-btn">
              <button class="btn btn-default" type="button" @click="dialog.color=!dialog.color">选择</button>
          </span>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label class="col-sm-2 control-label">瑕疵</label>
      <div class="col-sm-10">
        <div class="input-group">
          <input type="text" class="form-control" placeholder="瑕疵" v-model="flawRecordsView" disabled/>
          <span class="input-group-btn">
              <button class="btn btn-default" type="button" @click="dialog.flaws=!dialog.flaws">选择</button>
          </span>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label class="col-sm-2 control-label">备注</label>
      <div class="col-sm-10">
        <input type="text" class="form-control" placeholder="备注" v-model="clothe.mark"/>
      </div>
    </div>

    <modal v-model="dialog.price" title="类型价格" :backdrop="false" :footer="false">
      <selector-price @onSelected="onPriceSelected"></selector-price>
    </modal>
    <modal v-model="dialog.brand" title="选择品牌" :backdrop="false" :footer="false">
      <selector-brand @onSelected="onBrandSelected"></selector-brand>
    </modal>
    <modal v-model="dialog.color" title="选择颜色" :backdrop="false" :footer="false">
      <selector-color @onSelected="onColorSelected"></selector-color>
    </modal>
    <modal v-model="dialog.flaws" title="选择瑕疵" :backdrop="false" @hide="flawSelectorHide">
      <selector-flaw @onSelected="onFlawSelected"></selector-flaw>
      <div slot="footer">
        <button class="btn btn-default" @click="dialog.flaws=false">取消</button>
        <button class="btn btn-primary" @click="onBtnSelectFlawClick">确定</button>
      </div>
    </modal>
    
  </div>
</template>

<script>
import SelectorBrand from '@/components/selectors/Brand'
import SelectorColor from '@/components/selectors/Color'
import SelectorFlaw from '@/components/selectors/Flaw'
import SelectorPrice from '@/components/selectors/Price'

import * as TYPES from '../../store/types'

export default {
  props: ['clothe'],
  components: {
    SelectorBrand,
    SelectorColor,
    SelectorFlaw,
    SelectorPrice
  },
  data() {
    return {
      dialog: {
        color: false,
        brand: false,
        flaws: false,
        price: false
      }
    }
  },
  computed: {
    flawRecordsView() {
      return (this.clothe.flawRecords || []).map(val => {
        return val.text
      })
    }
  },
  methods: {
    flawSelectorHide() {
      console.log('hide')
      this.$store.commit(TYPES.RESET_FLAWS_SELECTOR)
      console.log('hide')
    },
    onBrandSelected(item) {
      this.clothe.brand = item
      this.dialog.brand = false
    },
    onColorSelected(item) {
      this.clothe.color = item
      this.dialog.color = false
    },
    onPriceSelected(item) {
      console.log(item)
      this.clothe.name = item.name
      this.clothe.price = item.priceString
      this.dialog.price = false
    },
    onFlawSelected(items) {
      this.clothe.flawRecords = items
      // this.flawRecordsView = []
      // this.clothe.flawRecords.forEach(element => {
      //   this.flawRecordsView.push(element.text)
      // })
    },
    onBtnSelectFlawClick() {
      this.dialog.flaws = false
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/forms/TicketClothe.vue